module.exports = __webpack_public_path__ + "img/brand-header.a73e091d.jpg";